import { BACKEND_URL } from "@/lib/api";

const src = (u) => (u?.profile_picture_url?.startsWith("/") ? `${BACKEND_URL}${u.profile_picture_url}` : u?.profile_picture_url);

export const Avatar = ({ user, className = "h-8 w-8", textClass = "text-xs" }) =>
  user?.profile_picture_url ? (
    <img src={src(user)} alt="" className={`${className} shrink-0 rounded-full object-cover`} />
  ) : (
    <span className={`ig-gradient grid shrink-0 place-items-center rounded-full font-medium uppercase text-white ${className} ${textClass}`}>
      {(user?.username || "?").slice(0, 1)}
    </span>
  );
